import { Link } from 'gatsby';
import gsap from 'gsap';
import React, { useEffect, useRef, useState } from 'react';
import ExternalLink from '../svgs/ExternalLink';
import { linkButton, linkButtonSmall } from './LinkButton.module.scss';

const LinkButton = ({ text, url, color, small }) => {
  const linkRef = useRef();
  const [hover, setHover] = useState(null);

  useEffect(() => {
    const hoverContext = gsap.context(() => {}, linkRef);
    return () => {
      hoverContext.revert();
    };
  }, [hover]);

  if (url.startsWith('http')) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={`${small ? linkButtonSmall : linkButton} ${
          // TODO replace Nightshadz
          color ? `varColor${color}` : 'varColorNightshadz'
        }`}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        ref={linkRef}
      >
        {text}{' '}
        <span className={`inlineIcon`}>
          <ExternalLink />{' '}
        </span>
      </a>
    );
  } else {
    return (
      <Link
        to={url}
        className={`${small ? linkButtonSmall : linkButton} ${
          // TODO replace Nightshadz
          color ? `varColor${color}` : 'varColorNightshadz'
        }`}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        ref={linkRef}
      >
        {text}
      </Link>
    );
  }
};

export default LinkButton;
